import React from 'react';

/** Shared library navigation for hobby lists, including their empty state. */
export default function HobbyLibrarySidebar({ title, allLabel, value, onChange, options = [] }) {
  return <aside className="recipe-books-panel" aria-label={title}>
    <p className="eyebrow">{title}</p>
    <div className="recipe-book-list">
      {[{ value: '', label: allLabel }, ...options].map(option => <button
        key={option.value}
        type="button"
        className={value === option.value ? 'active' : ''}
        aria-current={value === option.value ? 'page' : undefined}
        onClick={() => onChange(option.value)}
      ><span>{option.label}</span></button>)}
    </div>
  </aside>;
}
